
    import Vue from "vue";
    import Router from "vue-router";
    import { UserHelper } from "@/helpers/UserHelper";
    import { AssociationRoleEnum, AspNetRole, ApplicationSetting } from "./models/Enums";
    import { mapGetters } from "vuex";
    import setAuthorizationToken from "@/helpers/functions/AxiosToken";
    import SelectListItem from "@/models/SelectListItem";
    import { AssociationService } from "@/services/AssociationService";
    import Notify from "@/components/ui/Notify.vue";
    import SnackbarMessage from './models/SnackbarMessage';
    import { UserService } from './services/UserService';
    import { SnackbarService } from './services/SnackbarService';
    import UserInfo from './models/api/user/UserInfo';
    import AssociationUserInfo from './models/api/user/AssociationUserInfo';
    import { SettingService } from '@/services/SettingService';
    import colors from "vuetify/lib/util/colors"


import ApplicationSettingDto from './models/api/ApplicationSetting';

    Vue.use(Router);

    export default Vue.extend({
        name: "App",

        components: { Notify },

        data: () => ({
            showApp: false,
            showAssociationSelectMenu: false,
            showAssociationSelectMenu2: false,
            associationCookie: "" as string | null,
            showFlagsMenu: false,
            showMenu: false,
            showUserStatus: false,
            langs: [
                {
                    value: "sv",
                    text: "Svenska",
                    iconSrc: require("./assets/flags/sweden.svg"),
                },
                {
                    value: "en",
                    text: "English",
                    iconSrc: require("./assets/flags/united-kingdom.svg"),
                },
            ],
            associations: [] as SelectListItem[],
            associationSearchText: null as string | null,

            snackbarMessage: new SnackbarMessage("","",5000),
            showSnackbarMessage: false,

            selectedAssociationUserId: "",
            associationUserIds: [new SelectListItem("", "")],
        }),
        created() {
            //console.log(this.$store);
            setAuthorizationToken(this.userInfo.token);
            this.associationCookie = this.$cookies.get("selectedAssociation");
            this.showUserStatus = process.env.VUE_APP_SHOW_USER_STATUS == "true";        
            const storedCurrentLanguage = this.currentLanguage; // get from store
            if (!storedCurrentLanguage) {
                this.changeLanguage(this.$vuetify.lang.current);
            } else {
                this.$vuetify.lang.current = storedCurrentLanguage;
            }
            this.setTheme();
        },
        methods: {
            getApplicationSetting(settings: ApplicationSettingDto[], app: ApplicationSetting) : number {
                return settings.findIndex((val: any) => val.keyName == app);
            },
            getApplicationSettingColor(settings: ApplicationSettingDto[], app: ApplicationSetting) : string {
                let settingString = settings[this.getApplicationSetting(settings, app)].value.toString();
                let colorText = "";
                try {
                    colorText = JSON.parse(settingString);
                } catch (e) {
                    colorText = settingString;
                }

                return colorText;
            },
            async setTheme() {
                SettingService.GetSettingsByKeyNames("ThemeAccent,ThemeError,ThemeInfo,ThemePrimary,ThemeSecondary,ThemeSuccess,ThemeWarning")
                    .then((response) => {
                        const settings = response.data as ApplicationSettingDto[];
                        const themeAccent = this.getApplicationSettingColor(settings, ApplicationSetting.ThemeAccent);
                        const themeError = this.getApplicationSettingColor(settings, ApplicationSetting.ThemeError);
                        const themeInfo = this.getApplicationSettingColor(settings, ApplicationSetting.ThemeInfo);
                        const themePrimary = this.getApplicationSettingColor(settings, ApplicationSetting.ThemePrimary);
                        const themeSecondary = this.getApplicationSettingColor(settings, ApplicationSetting.ThemeSecondary);
                        const themeSuccess = this.getApplicationSettingColor(settings, ApplicationSetting.ThemeSuccess);
                        const themeWarning = this.getApplicationSettingColor(settings, ApplicationSetting.ThemeWarning);

                        this.$vuetify.theme.themes.light['accent'] = themeAccent;
                        this.$vuetify.theme.themes.light['error'] = themeError;
                        this.$vuetify.theme.themes.light['info'] = themeInfo;
                        this.$vuetify.theme.themes.light['primary'] = themePrimary;
                        this.$vuetify.theme.themes.light['secondary'] = themeSecondary;
                        this.$vuetify.theme.themes.light['success'] = themeSuccess;
                        this.$vuetify.theme.themes.light['warning'] = themeWarning;
                    })
                    .catch((error) => {
                        if (error.response.data.errors) {
                            console.log(error.response.data.errors.join("\n"));
                        } else {
                            console.log(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                        }

                        this.$vuetify.theme.themes.light['primary'] = colors.blue.darken4;
                        this.$vuetify.theme.themes.light['accent'] = colors.blue;
                        this.$vuetify.theme.themes.light['secondary'] = colors.lime;
                        this.$vuetify.theme.themes.light['success'] = colors.lightGreen;
                        this.$vuetify.theme.themes.light['error'] = colors.deepOrange.darken3;
                        this.$vuetify.theme.themes.light['warning'] = colors.amber;
                        this.$vuetify.theme.themes.light['info'] = colors.blueGrey;
                    })
                    .finally(() => {
                        this.showApp = true;
                    });

            },
            /*
             * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN Home.vue! Changes might need to be done there too!
             */
            async setAssociationUser() {
                this.$store.commit("addOverlay");
                UserService.SetAssociationUser(
                    { id: parseInt(this.selectedAssociationUserId) },
                    this.userInfo.token
                )
                    .then((response) => {
                        const userInfo = this.setValuesFromAuthenticationResponse(response);
                        this.handleAuthentication(userInfo);
                        this.showAssociationSelectMenu2 = false;
                    })
                    .catch((error) => {
                        if (error.response.data.errors) {
                            SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                        } else {
                            SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                        }
                    })
                    .finally(() => {
                        this.$store.commit("removeOverlay");
                    });
            },
            /*
             * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN Home.vue! Changes might need to be done there too!
             */
            setValuesFromAuthenticationResponse(response: any) {
                let userInfo = new UserInfo();
                userInfo.aspNetRole = response.data.role;
                userInfo.name = response.data.name;
                userInfo.isAuthenticated = true;
                userInfo.token = response.data.token as string;
                userInfo.hasMultipleAssociationUsers = response.data.hasMultipleAssociationUsers;

                if (response.data.associationUserInfo) {
                    userInfo.associationUserInfo = new AssociationUserInfo();
                    userInfo.associationUserInfo.id = response.data.associationUserInfo.id;
                    userInfo.associationUserInfo.role = response.data.associationUserInfo.role;
                    userInfo.associationUserInfo.name = response.data.associationUserInfo.name;
                    userInfo.associationUserInfo.associationName = response.data.associationUserInfo.associationName;
                } else {
                    userInfo.associationUserInfo = null;
                }

                return userInfo;
            },
            /*
             * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN Home.vue! Changes might need to be done there too!
             */
            handleAuthentication(userInfo: UserInfo) {

                //SessionHelper.sessionSetItem("UserInfo", userInfo);
                this.$store.commit("setUserInfo", userInfo);

                //console.log(userInfo);

                switch (userInfo.aspNetRole) {
                    case AspNetRole.SystemAdmin:
                        console.log("no page defined", AspNetRole.SystemAdmin.toString());
                        break;
                    case AspNetRole.MunicipalityAdmin:
                        console.log(
                            "User is ",
                            AspNetRole.MunicipalityAdmin.toString(),
                            "redirecting"
                        );
                        this.$router.push("/municipality");
                        return;
                    case AspNetRole.AssociationUser:
                        if (userInfo.associationUserInfo?.role == AssociationRoleEnum.AssociationAdmin) {
                            this.$router.push("/association");

                        } else {
                            this.$router.push("/association/occasions");
                        }
                        break;
                    default:
                        console.log("unhandled for user role", userInfo.aspNetRole);
                        break;
                }
            },
            /*
             * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN Home.vue! Changes might need to be done there too!
             */
            getAssociationUsers() {
                this.$store.commit("addOverlay");
                UserService.GetAssociationUsers(this.userInfo.token)
                    .then((response) => {
                        this.associationUserIds = response.data.items;
                        this.selectedAssociationUserId = this.userInfo.associationUserInfo.id.toString();

                        setTimeout(
                            () => {
                                ((this.$refs?.associationUserSelect as Vue).$el as HTMLElement)?.focus();
                            },
                            100
                        );
                       
                    })
                    .catch((error) => {
                        if (error.response.data.errors) {
                            SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                        } else {
                            SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                        }
                    })
                    .finally(() => {
                        this.$store.commit("removeOverlay");
                    });

            },
            getAssociationRoleName(role: AssociationRoleEnum) {
                return this.$vuetify.lang.t(
                    "$vuetify.association." + AssociationRoleEnum[role]
                );
            },
            getAspNetRoleName(role: AspNetRole) {
                return this.$vuetify.lang.t("$vuetify.user." + AspNetRole[role]);
            },
            logout(): void {
                UserHelper.logoff(this);
            },
            changeLanguage(lang: string): void {
                this.$vuetify.lang.current = lang;
                this.$store.commit("setCurrentLanguage", lang);
            },
            navigateToItem(url: string) {
                this.$router.push(url);
            },
            closeSnackbarMessage(): void {
                this.$store.commit("shiftSnackbarMessages");
                this.snackbarMessage = new SnackbarMessage("", "", 0);
                this.showSnackbarMessage = false;
            },
        },
        watch: {
            associationCookie() {
                if (this.associationCookie == "null") {
                    this.associationCookie = null;
                }

                if (this.associationCookie == this.selectedAssociation) {
                    // No change, so no need to do anything!
                    return;
                }

                let associationName = "" as string | undefined;

                if (this.associationCookie && this.associations.length > 0) {
                    associationName = this.associations.find(s => s.value == this.associationCookie)?.text;
                    this.$router.push("/association");
                } else if (window.location.href.indexOf("#/association") > -1){
                    this.$router.push("/");
                }

                this.$cookies.set("selectedAssociation", this.associationCookie);

                const associationCookie = this.associationCookie;
                this.$store.commit("setSelectedAssociation", { associationCookie, associationName });

                if (!this.associationCookie) {
                    setTimeout(
                        () =>
                            (
                                (this.$refs?.showAssociationSelectButton as Vue).$el as HTMLElement
                            )?.focus(),
                        100
                    );
                } else {
                    this.showAssociationSelectMenu = false;
                }
            },

            associationSearchText(val: string) {
                AssociationService.GetAssociationSelectListItems(val).then(response => {
                    this.associations = response.data;
                });
            },
            getSnackbarMessagesLength() {
                if (this.resetSnackbar) {
                    this.showSnackbarMessage = false;
                    this.$store.commit("resetSnackbarMessagesDone");
                } else if (this.getSnackbarMessagesLength > 0 && !this.showSnackbarMessage) {
                    setTimeout(() => { this.showSnackbarMessage = true; this.snackbarMessage = this.getSnackbarMessage; }, 200);
                }
            },
            isAuthenticated() {
                this.userInfo.isAuthenticated;
            },
            showMenu(val: boolean) {
                const initiator = this;
                if (val) {
                    setTimeout(
                        () =>
                            (
                                (initiator?.$refs?.homeRouterLink as Vue).$el as HTMLElement
                            )?.focus(),
                        100
                    );
                } else {
                    setTimeout(
                        () =>
                            ((initiator?.$refs?.menuIcon as Vue).$el as HTMLElement)?.focus(),
                        100
                    );
                }
            },
            showFlagsMenu(val: boolean) {
                const initiator = this;
                if (val) {
                    setTimeout(
                        () =>
                            (
                                (initiator?.$refs?.firstFlag as [Vue])[0].$el as HTMLElement
                            )?.focus(),
                        100
                    );
                } else {
                    setTimeout(
                        () =>
                            (
                                (initiator?.$refs?.showFlagsButton as Vue).$el as HTMLElement
                            )?.focus(),
                        100
                    );
                }
            },
            showAssociationSelectMenu(val: boolean) {
                const initiator = this;
                if (val) {
                    setTimeout(
                        () => {
                            (
                                (initiator?.$refs?.firstAssociation as Vue).$el as HTMLElement
                            )?.focus();
                            ((initiator?.$refs['firstAssociation']) as any)?.focus();
                        },
                        100
                    );
                } else {
                    setTimeout(
                        () =>
                            (
                                (initiator?.$refs?.unselectAssociationButton as Vue).$el as HTMLElement
                            )?.focus(),
                        100
                    );
                }
            },
            showAssociationSelectMenu2(val: boolean) {
                const initiator = this;
                if (val) {
                    setTimeout(
                        () => {
                            (
                                (initiator?.$refs?.associationUserSelect as Vue).$el as HTMLElement
                            )?.focus();
                            ((initiator?.$refs['associationUserSelect']) as any)?.focus();
                        },
                        100
                    );
                } else {
                    setTimeout(
                        () =>
                            (
                                (initiator?.$refs?.showAssociationSelectButton2 as Vue).$el as HTMLElement
                            )?.focus(),
                        100
                    );
                }
            },
        },
        computed: {
            getIcon() {
                return (item: any) => {
                    let image = item || this.$vuetify.lang.current;
                    let iconSrc = null;
                    Object.keys(this.langs).forEach((value: string, index: number) => {
                        if (this.langs[index].value === image) {
                            iconSrc = this.langs[index].iconSrc;
                        }
                    });
                    return iconSrc;
                };
            },
            showOverlay: function () {
                const overlayCounter = this.$store.getters.overlayCounter;
                return overlayCounter > 0;
            },
            ...mapGetters([
                "resetSnackbar",
                "getSnackbarMessage",
                "getSnackbarMessagesLength",
                "userInfo",
                "currentLanguage",
                "isAuthenticated",
                "isSystemAdmin",
                "isMunicipalityAdmin",
                "isAssociationUser",
                "isAssociationUser_GroupAdmin",
                "isAssociationUser_Admin",
                "showTabs",
                "selectedAssociationName",
                "selectedAssociation",
            ]),
        },
    });
